import { useEffect, useState } from "react"
import DatePicker from "react-datepicker"

import "react-datepicker/dist/react-datepicker.css"
import { createUseStyles, useTheme } from "react-jss"
import { useAppDispatch, useAppSelector } from "../util/hooks"
import {
  endDateChange,
  pipeLineFilterChange,
  pipeLineNamesAndRunIdsAsync,
  runIdChange,
  startDateChange,
} from "../features/Monitor/FilterSlice"
import { format, parse } from "date-fns"
import { Box } from "@mui/material"
import { DATE_FORMAT, MONTHS_DISPLAY_MAPPER } from "../util/StaticData"

const useStyles = createUseStyles({
  dateInput: {
    minWidth: 180,
    padding: 4,
    height: 26,
    borderRadius: 4,
    border: "lightgray 1px solid",
    "&:focus": {
      outline: "none",
      border: "2px solid #007bff",
      boxShadow: "0 0 5px rgba(0, 123, 255, 0.5)",
    },
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%", // You can keep this as a string or convert it to '1.5' for 150%
    marginRight: 10,
  },
  filterLabel: {
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%", // You can keep this as a string or convert it to '1.5' for 150%
    marginRight: 10,
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
})

const selectedDateMapper = (month: number, year: number) => {
  const start = new Date(year, month - 1, 1)

  const end = new Date(year, month, 0)
  const today = new Date()

  return [
    format(start > today ? today : start, DATE_FORMAT),
    format(end > today ? today : end, DATE_FORMAT),
  ]
}

export const ReactDatePicker = () => {
  const theme: any = useTheme()
  const classes = useStyles({ theme })
  const dispatch = useAppDispatch()
  const monthSelectedValue =
    Object.keys(MONTHS_DISPLAY_MAPPER).indexOf(
      useAppSelector((store) => store.filters.monthSelectedValue),
    ) + 1

  const yearSelectedValue = useAppSelector(
    (store) => store.filters.yearSelectedValue,
  )

  const selectedDate = selectedDateMapper(
    monthSelectedValue,
    parseInt(yearSelectedValue),
  )
  const startDate1 = useAppSelector((state) => state.filters.startDate)
  const endDate1 = useAppSelector((state) => state.filters.endDate)

  useEffect(() => {
    if (selectedDate[0]) {
      dispatch(startDateChange(selectedDate[0]))
    }
    if (selectedDate[1]) {
      dispatch(endDateChange(selectedDate[1]))
    }
  }, [selectedDate[0], selectedDate[1]])

  const [startDate, setStartDate]: any = useState(null)
  const [endDate, setEndDate]: any = useState(null)

  const onChange = (dates: any) => {
    try {
      const [start, end] = dates
      if (start !== null) {
        setStartDate(start)
        dispatch(startDateChange(format(start, DATE_FORMAT)))
      }
      // if (end !== null) {
      setEndDate(end)
      dispatch(endDateChange(format(end, DATE_FORMAT)))
      // }
      dispatch(pipeLineFilterChange(""))
      dispatch(runIdChange(""))
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (startDate1) {
      setStartDate(parse(startDate1, DATE_FORMAT, new Date()))
    }
    if (endDate1) {
      setEndDate(parse(endDate1, DATE_FORMAT, new Date()))
    }
  }, [startDate1, endDate1])

  useEffect(() => {
    if (startDate1 && endDate1) {
      dispatch(pipeLineNamesAndRunIdsAsync())
    }
  }, [startDate1, endDate1])

  return (
    <div className={classes.wrapper}>
      <div className={classes.filterLabel}>Date :</div>
      <Box sx={{ minWidth: 180 }}>
        <DatePicker
          className={classes.dateInput}
          // selected={startDate}
          onChange={onChange}
          startDate={startDate}
          endDate={endDate}
          selectsRange={true}
          maxDate={new Date()}
          dateFormat={DATE_FORMAT}
          // inline
        />
      </Box>
    </div>
  )
}
